<template>
  <div :style="{ padding: '0 50px', marginTop: '64px', zIndex: 1 }">
    <div :style="{ background: '#fff', padding: '24px', minHeight: '880px' }">
      <h1>Economic effects of population aging</h1>
      <a-row>
        <a-row :gutter="14">
          <a-col :span="11" :xs="24" :sm="24" :md="24" :lg="11">
            <GDPgrouthChart/>
          </a-col>
          <a-col :span="13" :xs="24" :sm="24" :md="24" :lg="13">
            <HealthPensionChart/>
          </a-col>
        </a-row>
        <a-row :gutter="2"><svg height="100px"></svg></a-row>
        <a-row :gutter="14">
        <a-col :span="12" :xs="24" :sm="24" :md="24" :lg="12">
            <ExpImpChart/>
          </a-col>
          <a-col :span="12" :xs="24" :sm="24" :md="24" :lg="12">
            <ExchangeRateChart/>
          </a-col>
        </a-row>
      </a-row>
      
      
    </div>
  </div>
</template>

<script>
// import * as d3 from "d3";
import GDPgrouthChart from "../components/affect/Economy/GDPChart.vue"
import ExpImpChart from "../components/affect/Economy/ExpImpChart.vue"
import ExchangeRateChart from "../components/affect/Economy/ExchangeRateChart.vue"
import HealthPensionChart from "../components/affect/Economy/HealthPensionChart.vue"
export default {
  name: "Affect",
  components:{
    GDPgrouthChart,
    ExpImpChart,
    ExchangeRateChart,
    HealthPensionChart
  }
};
</script>
<style>
body {
  font-family: "Lato", sans-serif;
  font-size: 16px;
  font-weight: normal;
  color: #555;
}

h1 {
  padding: 10px;
  margin: 20px 0px 0px 0px;
  font-size: 1.8em;
  text-align: center;
}
h2 {
  padding: 0px;
  margin: 20px 0px 0px 0px;
  font-size: 1.5em;
}
h3 {
  padding: 0px;
  margin: 20px 0px 0px 0px;
  font-size: 1.2em;
  text-align: center;
}

h4 {
  padding: 0px;
  margin: 20px 0px 0px 0px;
  font-size: 1em;
}

</style>